import BrandCard from './BrandCard';

const BrandGrid = ({ categorySlug, brands, isDarkMode, city }) => {
  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10">
      {brands.map((brand, index) => {
        return (
          <BrandCard
            key={brand?.id || index}
            brand={brand}
            isDarkMode={isDarkMode}
            city={city}
            categorySlug={categorySlug}
          />
        );
      })}
    </div>
  );
};

export default BrandGrid;